import { applyPatch as s } from "fast-json-patch";
import { logger as o } from "./config.es.js";
const d = (t) => {
  var a;
  return (a = t == null ? void 0 : t.data) == null ? void 0 : a.data;
}, p = (t) => d(t.data), l = (t, a = 0) => {
  var e, c;
  return (c = (e = t == null ? void 0 : t.pages[a]) == null ? void 0 : e.data) == null ? void 0 : c.data;
}, h = (t, a = 0) => l(t.data, a), y = (t, a, e = void 0, ...c) => {
  var n, u;
  try {
    return s(t, a, ...c).newDocument;
  } catch (i) {
    return (n = o) == null || n.logLvl(3, i, t, a), (u = o) == null || u.report(i), e;
  }
}, m = (t, a, e) => {
  if (t.op !== "add" || !t.path.endsWith("/-")) return !0;
  const c = t.path.split("/").slice(1, -1);
  let n = e;
  for (const u of c)
    n[u] === null && (n[u] = []), n = n[u];
  return !0;
}, D = (t) => {
  var e;
  if (!t || typeof t != "object") return;
  const a = ((e = t == null ? void 0 : t.data) == null ? void 0 : e.code) || (t == null ? void 0 : t.code);
  return a ? Number(a) : void 0;
};
export {
  D as getApiResponseCode,
  h as getInfinityQueryRequestData,
  l as getInfinityRequestData,
  p as getQueryRequestData,
  d as getRequestData,
  y as jsonPatch,
  m as jsonPatchArrayFallbackValidator
};
